<script setup>
import { computed, ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';

import mercadolibreClient from 'dashboard/api/channel/mercadolibreClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

const siteId = computed(() => props.inbox.site_id);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await mercadolibreClient.generateAuthorization({
      site_id: siteId.value,
      inbox_id: props.inbox.id,
    });

    const {
      data: { url },
    } = response;

    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.MERCADOLIBRE.ERROR_AUTH'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <InboxReconnectionRequired class="mx-6" @reauthorize="requestAuthorization" />
</template>
